import { Component, HostBinding, inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConversationUIModule } from '../../../ui/src/conversation-ui.module';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { ConversationListService } from '../../../core/src/lib/state/conversation-list.service';
import { isMobile } from '../../../core/src/lib/inbox-utils';
import { ActivatedRoute, NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { filter, map, Observable, startWith } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { MatAnchor, MatButton } from '@angular/material/button';
import { INBOX_SERVICE_PROVIDERS } from '../../../core/src/lib/conversation-core.module';

@Component({
  selector: 'inbox-container-v2',
  imports: [
    CommonModule,
    ConversationUIModule,
    GalaxyPageModule,
    MatIcon,
    MatMenu,
    RouterOutlet,
    MatMenuTrigger,
    TranslateModule,
    MatButton,
    MatMenuItem,
    RouterLink,
    MatAnchor,
  ],
  templateUrl: './inbox-container-v2.component.html',
  styleUrl: './inbox-container-v2.component.scss',
  providers: [INBOX_SERVICE_PROVIDERS],
})
export class InboxContainerV2Component implements OnInit, OnDestroy {
  initialViewportHeight: number | undefined;
  @HostBinding('style.--viewport-height') viewportHeight: string | undefined;
  readonly organizationHasConversations$ = inject(ConversationListService).organizationHasConversations$;

  protected showToolbarOnMobile$: Observable<boolean> | undefined;
  private resizeListener: (() => void) | undefined;
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  ngOnInit(): void {
    this.showToolbarOnMobile$ = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.route.firstChild?.snapshot?.data?.['showToolbarOnMobile'] ?? false),
      startWith(this.route.firstChild?.snapshot?.data?.['showToolbarOnMobile'] ?? false),
    );

    this.initialViewportHeight = window.visualViewport?.height ?? window.innerHeight;

    this.resizeListener = () => this.updateViewportHeight();
    window.visualViewport?.addEventListener('resize', () => this.updateViewportHeight());
  }

  ngOnDestroy(): void {
    window.visualViewport?.removeEventListener('resize', this.resizeListener);
  }

  private updateViewportHeight(): void {
    const viewportHeight = window.visualViewport?.height ?? window.innerHeight;

    // Scroll to the top if the viewport height decreases significantly (when the keyboard opens)
    if (viewportHeight < this.initialViewportHeight * 0.8) {
      window.scrollTo(0, 0);
    }

    this.viewportHeight = `${viewportHeight}px`;
  }

  get isMobile(): boolean {
    return isMobile();
  }
}
